import { useEffect, useRef } from 'react';

export const NumberwithComma = (item: number | string) => {
  const num = Number(item);

  return num.toFixed(1).toLocaleString();
};

export const ReportFormatNumber = (
  item: number | string | null,
  percent?: boolean,
  showUnit: boolean = true,
) => {
  const num = Number(item);

  if (percent) {
    return num.toFixed(1) + (showUnit ? ' %' : '');
  } else if (!percent && num) {
    return num.toLocaleString() + (showUnit ? ' 원' : ''); // percent가 false이면 '원'을 붙임
  } else {
    return '-';
  }
};

export const useDidMountEffect = (func: any, deps: any) => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) func();
    else didMount.current = true;
  }, deps);
};

export const formatCurrency = (value: number) => {
  let formattedValue;
  if (value === null) {
    return '- 원';
  }
  if (value >= 1000_0000) {
    // 억 단위로 변환
    formattedValue = (value / 1_0000_0000).toFixed(1).toLocaleString() + '억';
  } else if (value >= 1_0000) {
    // 만 단위로 변환
    formattedValue = (value / 1_0000).toFixed(0).toLocaleString() + '만원';
  } else {
    // 원 단위 그대로
    formattedValue = value.toLocaleString() + '원';
  }

  return formattedValue;
};

// 만원 단위 숫자를 한글로 변환하는 함수(억 + 만 단위)
export const formatToEokMan = (value: any) => {
  if (value === null) {
    return '-원';
  }
  if (value < 10000) {
    return value.toLocaleString() + '원';
  }
  if (typeof value !== 'number') {
    value = Number(value);
  }
  const eok = Math.floor(value / 100000000); // 억 단위
  const man = Math.round((value % 100000000) / 10000); // 만 단위 (반올림)

  let result = '';

  if (eok > 0) {
    result += `${eok.toLocaleString()}억 `;
  }

  if (man > 0) {
    result += `${man.toLocaleString()}만원`;
  }

  return result.trim();
};

export const utilTransNum = (num: number) => {
  num = Number(num);
  if (num === 0) return '0';
  else if (typeof num !== 'number') {
    return '0';
  } else if (num < 10000) {
    return Math.round(num).toLocaleString();
  } else if (num < 100000000) {
    return Math.round(num / 10000).toLocaleString() + '만';
  } else if (num < 1000000000000) {
    const value = num / 100000000;
    return Number(value.toFixed(1)).toLocaleString() + '억';
  } else {
    const value = num / 1000000000000;
    return Number(value.toFixed(1)).toLocaleString() + '조';
  }
};
